<div class="flex flex-col w-[100vw] h-[100vh] py-12">
    @if (!isCorrectPassword) {
        <form
            [formGroup]="ganttForm"
            class="flex flex-col gap-8 items-center my-auto mx-[20vw] min-w-[400px]"
        >
            <div class="text-xl">
                Please enter password to view the Schedule.
            </div>
            <mat-form-field
                class="w-full fuse-mat-dense"
                [subscriptSizing]="'dynamic'"
            >
                <mat-label>Password</mat-label>
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_solid:lock-closed'"
                    matSuffix
                ></mat-icon>
                <input
                    name="password"
                    type="password"
                    [formControlName]="'password'"
                    matInput
                />
            </mat-form-field>
            <button
                mat-flat-button
                type="submit"
                [color]="'primary'"
                (click)="tryLogin()"
                [disabled]="!ganttForm.valid || ganttForm.pristine"
            >
                View
            </button>
        </form>
    }

    @if (isCorrectPassword) {
        <div class="w-full max-w-7xl min-w-[70vw] mx-auto">
            <div class="flex gap-4 ml-2 pt-12 pb-8 items-center">
                <div class="flex-0 h-10 overflow-hidden">
                    <img
                        class="w-full h-full"
                        src="assets/images/logo/HC_red.png"
                    />
                </div>
                <div class="text-xl">Project Schedule</div>
            </div>
            <div class="control-section">
                <ejs-gantt
                    #projectGantt
                    id="projectGantt"
                    height="600px"
                    [treeColumnIndex]="0"
                    dateFormat="d MMM, yyyy"
                    workUnit="Hour"
                    [projectStartDate]="projectStartDate"
                    [projectEndDate]="projectEndDate"
                    [workWeek]="[
                        'Sunday',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday'
                    ]"
                    [taskFields]="taskSettings"
                    [labelSettings]="labelSettings"
                    [editSettings]="editSettings"
                    [selectionSettings]="selectionSettings"
                    [dataSource]="data"
                    [columns]="columns"
                    [toolbar]="toolbarItems"
                    [resourceFields]="resourceFields"
                    [resources]="resources"
                    [allowSelection]="false"
                    [highlightWeekends]="true"
                    [allowRowDragAndDrop]="false"
                    [allowPdfExport]="true"
                    [allowParentDependency]="false"
                    (toolbarClick)="toolbarClickHandler($event)"
                    (cellSelecting)="cellSelecting($event)"
                    (actionBegin)="actionBegin($event)"
                    (actionComplete)="actionComplete($event)"
                    (taskbarEditing)="taskbarEditing($event)"
                    (taskbarClick)="taskbarClick($event)"
                    (queryTaskbarInfo)="queryTaskbar($event)"
                    (queryCellInfo)="queryCellEvent($event)"
                    (dataBound)="onDataBound()"
                >
                </ejs-gantt>
                <ng-template #taskbarTemplate let-data>
                    <div class="custom-taskbar">
                        <!-- Example icon -->
                        <mat-icon
                            class="mr-1"
                            [svgIcon]="'heroicons_solid:cake'"
                        >
                        </mat-icon>
                        {{ data.taskName }}
                    </div>
                </ng-template>
            </div>
        </div>
    }
</div>
